// Reference actions are stateless option lookups (RFC: reference-data actions);
// they are invoked by form widgets, never configured, so they must not render
// as configuration forms anywhere.
export const isConfigurableAction = (item: any, exclude: "push" | "pull"): boolean =>
  !!item && item.type !== exclude && item.type !== "reference";

export const filterConfigurableActions = (actions: any[] | undefined | null, exclude: "push" | "pull") =>
  (actions ?? []).filter((item) => isConfigurableAction(item, exclude));
